import { TableColumn } from '../../models/client/reports'

export const INVENTORY_VIEW_OPTIONS = [
  {
    label: 'In the yard',
    value: 'ingate',
  },
  // Not available in the current version
  // {
  //   label: 'Outgated',
  //   value: 'outgate',
  // },
]

export const TRUCK_CLASS_OPTIONS = [
  {
    label: 'Class 3',
    value: '3',
  },
  {
    label: 'Class 7',
    value: '7',
  },
  {
    label: 'Class 8',
    value: '8',
  },
]

export const TRUCK_FUEL_TYPE_OPTIONS = [
  {
    label: 'D - Diesel',
    value: 'D',
  },
  {
    label: 'NZE - Near Zero Emission',
    value: 'NZE',
  },
  {
    label: 'ZE - Zero Emission',
    value: 'ZE',
  },
]

export const ROW_TRUCK_FUEL_TYPE_OPTIONS = [
  {
    label: 'Diesel',
    value: 'D',
  },
  {
    label: 'Near Zero Emission',
    value: 'NZE',
  },
  {
    label: 'Zero Emission',
    value: 'ZE',
  },
  {
    label: 'CNG',
    value: 'CNG',
  },
]

export const TABLE_FILTER_OPTIONS = [
  { label: 'Carrier name', value: 'vehicle.carrier.name', category: 'general' },
  { label: 'Load #', value: 'load.number', category: 'load' },
  { label: 'Load License Plate #', value: 'load.licensePlate', category: 'load' },
  { label: 'Load type', value: 'load.type.name', category: 'load' },
  { label: 'Chassis #', value: 'chassis.number', category: 'chassis' },
  { label: 'Chassis License Plate #', value: 'chassis.licensePlate', category: 'chassis' },
  { label: 'Vehicle Truck #', value: 'vehicle.number', category: 'vehicle' },
  { label: 'Vehicle DOT #', value: 'vehicle.dotNumber', category: 'vehicle' },
  { label: 'Vehicle Class', value: 'vehicle.weightClass', category: 'vehicle' },
  { label: 'Vehicle Fuel Type', value: 'vehicle.fuelType', category: 'vehicle' },
  { label: 'Vehicle License Plate #', value: 'vehicle.licensePlate', category: 'vehicle' },
  { label: 'Vehicle Type', value: 'vehicle.type.name', category: 'vehicle' },
]

export const REQUIRED_FIELD_MESSAGE = 'This field is required'
